// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  ************************************************************
   *   PAGE DE LOGIN
   *  ************************************************************/  
   .login-fulldiv
   {
      width: 100%;
      height: 100%;
      
      
      
   }
   
   .login-imgftva {
     
     position: absolute;
     margin-top: 1%;
     margin-right: 1%;
     width : 98%;
     text-align: right;
   }
   
 
   .login-imglogo {
    top:35%;
    left: 10%;
     background-color: transparent;
     position: absolute;
     height : 30%;
   }

   .login-div-logout{

    position: absolute;
    margin-top: 20%;
    margin-left: 70%;
    width : 40%;
    height: 300px;
    
    
  }

  .login-div-login{
    position: absolute;
    margin-top: 16%;
    margin-left: 65%;
    width : 20%;
    height: 500px;
  }


  .login-formLogin {
    
    min-width: 100%;
    width: 100%;
    
    font-family: Arial;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    min-height: 30%;
    
    margin-top: 0;
    border-radius: 10px;
    border-color: var(--default-icon-color);
    border-style:solid;
    box-shadow: 8px 8px 8px  #252525;
    
    background-color: var(--panel-color-background-default);
  }  

  .login-div-login-button
  {
    width:96px;
    margin-right: 20px;
    margin-top: 10px;
    float:right;
    margin-bottom: 20px;
    
  }


  .login-formUser-titre
{
    font-size: 28px;
    width: 98%;
    color: #B0B0B0; 
    vertical-align: middle;
    
    text-align: right;
    
    margin-top: 20px;
    margin-bottom: 40px;
    margin-right: 5px;
}

.login-formUser-label {
    margin-bottom: 0.5em;
    color: var(--default-icon-color);
    text-align: left;
    font-weight: lighter;
    margin-left: 35px;
    margin-right: 35px;
    
  }
  .login-formUser-label-red {
    margin-bottom: 0.5em;
    color: #FF0000;
    text-align: left;
    font-size: 15px;
    font-weight: lighter;
    margin-left: 35px;
    margin-right: 35px;
    
  }

  .login-formUser-input {
    display: flex;
    font-size: 14px;
    
    flex-direction: column;
    margin-top: 5px;
    border-radius: 6px;
    border-color: black;
    background-color: #fefefe;
      

    width: 100%;
}

.label-formUser-titre-image
{
    position:absolute;
    margin-top: 4%;
    margin-left: 4%;
}
  
.login-div-login-sso
{
  font-size: 14px;
  margin-left: 5%;
  margin-right: 5%;
  width: 90%;
  height: 64px;
  color: #FFFFFF;

}`, "",{"version":3,"sources":["webpack://./src/applications/appstyles/login.css"],"names":[],"mappings":"AAAA;;kEAEkE;GAC/D;;MAEG,WAAW;MACX,YAAY;;;;GAIf;;GAEA;;KAEE,kBAAkB;KAClB,cAAc;KACd,gBAAgB;KAChB,WAAW;KACX,iBAAiB;GACnB;;;GAGA;IACC,OAAO;IACP,SAAS;KACR,6BAA6B;KAC7B,kBAAkB;KAClB,YAAY;GACd;;GAEA;;IAEC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;;;EAGf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;;;EAGA;;IAEE,eAAe;IACf,WAAW;;IAEX,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,eAAe;;IAEf,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;IAClB,gCAAgC;;IAEhC,uDAAuD;EACzD;;EAEA;;IAEE,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;;EAErB;;;EAGA;;IAEE,eAAe;IACf,UAAU;IACV,cAAc;IACd,sBAAsB;;IAEtB,iBAAiB;;IAEjB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;IAChC,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;;EAEpB;EACA;IACE,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;;EAEpB;;EAEA;IACE,aAAa;IACb,eAAe;;IAEf,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;;;IAGzB,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,cAAc;;AAEhB","sourcesContent":["/*  ************************************************************\n   *   PAGE DE LOGIN\n   *  ************************************************************/  \n   .login-fulldiv\n   {\n      width: 100%;\n      height: 100%;\n      \n      \n      \n   }\n   \n   .login-imgftva {\n     \n     position: absolute;\n     margin-top: 1%;\n     margin-right: 1%;\n     width : 98%;\n     text-align: right;\n   }\n   \n \n   .login-imglogo {\n    top:35%;\n    left: 10%;\n     background-color: transparent;\n     position: absolute;\n     height : 30%;\n   }\n\n   .login-div-logout{\n\n    position: absolute;\n    margin-top: 20%;\n    margin-left: 70%;\n    width : 40%;\n    height: 300px;\n    \n    \n  }\n\n  .login-div-login{\n    position: absolute;\n    margin-top: 16%;\n    margin-left: 65%;\n    width : 20%;\n    height: 500px;\n  }\n\n\n  .login-formLogin {\n    \n    min-width: 100%;\n    width: 100%;\n    \n    font-family: Arial;\n    font-size: 20px;\n    display: flex;\n    flex-direction: column;\n    min-height: 30%;\n    \n    margin-top: 0;\n    border-radius: 10px;\n    border-color: var(--default-icon-color);\n    border-style:solid;\n    box-shadow: 8px 8px 8px  #252525;\n    \n    background-color: var(--panel-color-background-default);\n  }  \n\n  .login-div-login-button\n  {\n    width:96px;\n    margin-right: 20px;\n    margin-top: 10px;\n    float:right;\n    margin-bottom: 20px;\n    \n  }\n\n\n  .login-formUser-titre\n{\n    font-size: 28px;\n    width: 98%;\n    color: #B0B0B0; \n    vertical-align: middle;\n    \n    text-align: right;\n    \n    margin-top: 20px;\n    margin-bottom: 40px;\n    margin-right: 5px;\n}\n\n.login-formUser-label {\n    margin-bottom: 0.5em;\n    color: var(--default-icon-color);\n    text-align: left;\n    font-weight: lighter;\n    margin-left: 35px;\n    margin-right: 35px;\n    \n  }\n  .login-formUser-label-red {\n    margin-bottom: 0.5em;\n    color: #FF0000;\n    text-align: left;\n    font-size: 15px;\n    font-weight: lighter;\n    margin-left: 35px;\n    margin-right: 35px;\n    \n  }\n\n  .login-formUser-input {\n    display: flex;\n    font-size: 14px;\n    \n    flex-direction: column;\n    margin-top: 5px;\n    border-radius: 6px;\n    border-color: black;\n    background-color: #fefefe;\n      \n\n    width: 100%;\n}\n\n.label-formUser-titre-image\n{\n    position:absolute;\n    margin-top: 4%;\n    margin-left: 4%;\n}\n  \n.login-div-login-sso\n{\n  font-size: 14px;\n  margin-left: 5%;\n  margin-right: 5%;\n  width: 90%;\n  height: 64px;\n  color: #FFFFFF;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
